"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonnelError = void 0;
const personnelErrorMessages_1 = require("./personnelErrorMessages");
class PersonnelError {
    constructor(code, optMessage) {
        this.code = code;
        if (!optMessage) {
            this.message = personnelErrorMessages_1.PERSONNEL_ERROR_MESSAGES[code];
        }
        else {
            this.message = optMessage;
        }
    }
    toPlainObject() {
        return { code: this.code, message: this.message };
    }
}
exports.PersonnelError = PersonnelError;
//# sourceMappingURL=personnelError.js.map